import { Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { RedirectComponent } from './_core/redirect.component';
import { authGuard } from './_core/auth.guard';
import { Home } from './home/home';
import { LayoutComponent } from './ggm/layout.component';
import { SendNotification } from './send-notification/send-notification';
import { Buildings } from './buildings/buildings';
import { Loading } from './loading/loading';
import { SendReading } from './send-reading/send-reading';
import { buildingGuard } from './_core/building.guard';
import { billingGuard } from './_core/billing.guard';
import { gatewayGuard } from './_core/gateway.guard';
import { alarmGuard } from './_core/alarm.guard';
import { ggmBrandGuard, ggmSimulationGuard, sendRequestsGuard } from './_core/branding.guard';
import { AddBuilding } from './buildings/add-building/add-building';
import { SettlementEmails } from './settings/settlement-emails/settlement-emails';
import { Contact } from './settings/contact/contact';
import { Help } from './settings/help/help';
import { Account } from './settings/account/account';
import { Billings } from './billings/billings';
import { Readings } from './readings/readings';

import { DailyReadings } from './readings/daily-readings/daily-readings';

import { TenantDetailsComponent } from './settings/tenant-details/tenant-details';

import { Alarms } from './alarms/alarms';
import { Notifications } from './notifications/notifications';
import { AutologinComponent } from './auth/autologin/autologin.component';
import { SimulacionLiquidacion } from './simulacion-liquidacion/simulacion-liquidacion';

export const routes: Routes = [
  { path: '', component: RedirectComponent },

  { path: 'autologin', component: AutologinComponent },
  { path: 'login', component: AuthComponent, data: { module: 'LOGIN' } },
  { path: 'login-demostracion', component: AuthComponent, data: { module: 'DEMO' } },
  { path: 'register', component: AuthComponent, data: { module: 'REGISTER' } },
  { path: 'recovery', component: AuthComponent, data: { module: 'RECOVERY' } },
  { path: 'change-password', component: AuthComponent, data: { module: 'CHANGE_PASSWORD' } },
  { path: 'loading', component: Loading },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'home', component: Home, canActivate: [buildingGuard] },
      { path: 'propiedades', component: Buildings },
      { path: 'propiedades-añadir', component: AddBuilding },
      { path: 'consumos', component: Readings, canActivate: [buildingGuard, billingGuard] },
      {
        path: 'lecturas-diarias',
        component: DailyReadings,
        canActivate: [buildingGuard, gatewayGuard],
      },
      { path: 'liquidaciones', component: Billings, canActivate: [buildingGuard, billingGuard] },
      {
        path: 'enviar-consulta',
        component: SendNotification,
        canActivate: [buildingGuard, sendRequestsGuard],
      },
      {
        path: 'enviar-lectura',
        component: SendReading,
        canActivate: [buildingGuard, billingGuard],
      },
      {
        path: 'simulacion-liquidacion',
        component: SimulacionLiquidacion,
        canActivate: [buildingGuard, billingGuard, ggmSimulationGuard],
      },
      {
        path: 'recibo-verde',
        component: SettlementEmails,
        canActivate: [buildingGuard, billingGuard, ggmBrandGuard],
      },
      { path: 'contacto', component: Contact },
      { path: 'ayuda', component: Help, canActivate: [ggmBrandGuard] },
      { path: 'configuracion', component: Account, canActivate: [buildingGuard] },
      { path: 'alarmas', component: Alarms, canActivate: [buildingGuard, alarmGuard] },
      { path: 'notificaciones', component: Notifications },
      { path: 'abonado', component: TenantDetailsComponent, canActivate: [buildingGuard] },
    ],
  },
  { path: 'redirect', component: RedirectComponent },
  { path: '**', redirectTo: '/redirect', pathMatch: 'full' },
];
